import i18n from 'i18next';
import { getLocaleMetadata, getSupportedLocale } from './locales';

const GOOGLE_TRANSLATE_META_ID = 'rentbhai-google-translate-control';

export const applyDocumentLocale = (language?: string | null) => {
  const locale = getLocaleMetadata(language);
  document.documentElement.lang = locale.htmlLang;
  document.documentElement.dir = locale.dir || 'ltr';
};

export const shouldSuppressBrowserTranslation = (language?: string | null) => {
  return getSupportedLocale(language) !== 'en';
};

export const setBrowserTranslationSuppressed = (suppressed: boolean) => {
  let meta = document.getElementById(GOOGLE_TRANSLATE_META_ID) as HTMLMetaElement | null;

  if (suppressed) {
    if (!meta) {
      meta = document.createElement('meta');
      meta.id = GOOGLE_TRANSLATE_META_ID;
      meta.name = 'google';
      document.head.appendChild(meta);
    }
    meta.content = 'notranslate';
    document.documentElement.classList.add('notranslate');
    document.documentElement.setAttribute('translate', 'no');
    document.body.classList.add('notranslate');
    document.body.setAttribute('translate', 'no');
    return;
  }

  meta?.remove();
  document.documentElement.classList.remove('notranslate');
  document.documentElement.removeAttribute('translate');
  document.body.classList.remove('notranslate');
  document.body.removeAttribute('translate');
};

export const getCurrentI18nLanguage = () => i18n.resolvedLanguage || i18n.language;
